import { useMemo } from 'react'

import apps from '@/apps'
import { useAuthSelector } from '@/store'

export default function useAvailableApps() {
  const { email } = useAuthSelector()

  return useMemo(() => {
    const isJourneyEmail = email?.toLowerCase().endsWith('@journeyid.com')
    return apps.filter(({ isReleased }) => isReleased || isJourneyEmail)
  }, [email])
}
